import type { LineId } from './lines';
import manifestFile from './manifest.json';

export const VOICE_KINDS = ['mujer', 'hombre'] as const;
export type VoiceKind = (typeof VOICE_KINDS)[number];

export type Manifest = {
  /** Who was recorded: the voices of the ElevenLabs library behind each choice. */
  voices: Record<VoiceKind, { name: string; voiceId: string; model: string }>;
  /** Per line: the exact words that were recorded and how long each recording lasts, in milliseconds. */
  clips: Partial<Record<LineId, { text: string } & Record<VoiceKind, number>>>;
};

/** Written by `scripts/voice-manifest.mjs` from the files in public/voces; never by hand. */
export const MANIFEST: Manifest = manifestFile;

export type Clip = { url: string; ms: number };

export function clipUrl(voice: VoiceKind, id: LineId): string {
  return `/voces/${voice}/${id}.mp3`;
}

export function clipFor(voice: VoiceKind, id: LineId): Clip | null {
  const ms = MANIFEST.clips[id]?.[voice];
  return ms ? { url: clipUrl(voice, id), ms } : null;
}
